import { ComponentProps } from 'react';
import classNames from 'classnames';
import { ChevronDownIcon } from 'app/agriculture/icons';
import { Button } from 'app/agriculture/components/Button/Button';
import { Popover } from 'app/agriculture/components/Popover/Popover';
import './PopoverMenu.scss';

interface PopoverMenuProps {
    trigger: Omit<ComponentProps<typeof Button>, 'onClick'>;
    items: ComponentProps<typeof Button>[];
}

export function PopoverMenu({ items, trigger }: PopoverMenuProps) {
    if (items.length === 0) return null;

    return (
        <Popover>
            <Popover.Trigger>
                <Button
                    {...trigger}
                    className={classNames(trigger.className, 'PopoverMenu__trigger')}
                    endIcon={<ChevronDownIcon />}
                />
            </Popover.Trigger>
            <Popover.Content disablePadding>
                <div className="PopoverMenu">
                    {items.map((item) => (
                        <Button
                            key={`${item.id} - ${item.text}`}
                            {...item}
                            variant="textonly"
                            className={classNames('PopoverMenu__item', item.className)}
                        />
                    ))}
                </div>
            </Popover.Content>
        </Popover>
    );
}
